import React from 'react';
import { Card } from '../ui/card';
import { cn } from '../../lib/utils';

/**
 * GlassCard Component
 * 
 * A glass-morphism styled card with backdrop blur, subtle borders, and optional hover effects.
 * Used throughout the app for strategy cards, testimonials, and floating UI elements.
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Card content
 * @param {string} props.className - Additional Tailwind classes
 * @param {boolean} props.hover - Enable hover effects (default: false)
 * @param {string} props.testId - data-testid attribute
 * @returns {JSX.Element}
 */
export const GlassCard = ({ 
  children, 
  className = '', 
  hover = false,
  testId = 'glass-card',
  ...props 
}) => {
  return (
    <Card
      className={cn(
        // Glass-morphism base styles
        'backdrop-blur-xl bg-white/5 dark:bg-white/6',
        'border border-white/10',
        'rounded-xl',
        'shadow-[0_12px_40px_rgba(0,0,0,0.28)]',
        // Inner glow
        'shadow-[inset_0_1px_0_rgba(255,255,255,0.12)]',
        // Hover effects (optional)
        hover && 'transition-all duration-300 hover:bg-white/8 hover:border-white/20 hover:shadow-glass-lg',
        className
      )}
      data-testid={testId}
      {...props}
    >
      {children}
    </Card>
  );
};